export default __webpack_public_path__ + "static/media/burger.9066589d.svg";